module.exports = __webpack_public_path__ + "static/img/papugawr.60308401.webp";